import {Injectable} from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
// Import our authentication service
import {AuthService} from './auth.service';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private auth: AuthService, private router: Router) {


  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let url = state.url;
    let split_url = url.split('/');

    // If user is not logged in we'll send them to the homepage
    if (!this.auth.loggedIn()) {
      this.auth.logout();
      this.router.navigate(['logout']).then(() => {
        return false;
      });
    }

    switch (this.auth.getLoginType()) {
      case 'Volunteer':
        if (!split_url.includes('volunteer-agreement')) {

          return false
        }
        break;
      case 'TCP':
        if (!split_url.includes('tcp')) {
          return false
        }
        break;
      case 'AuthorizedRep':
        if (!split_url.includes('authorized-rep')) {
          return false
        }
        break;
    }
    return true;
  }

}

@Injectable()
export class LoginAuthGuard implements CanActivate {

  constructor(private auth: AuthService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // do not let users access login page if they are already logged in
    if (!this.auth.loggedIn()) {
      return true;
    }
    // this.router.navigate(['']);
  }

}

@Injectable()
export class PostLoginAuthGuard implements CanActivate {

  constructor(private auth: AuthService, private router: Router) { }

  canActivate() {
    // If user is not authenticating we'll send them to the homepage
    if (!this.auth.loggedIn() && this.auth.authenticating()) {
      return true;
    }
    this.router.navigate(['']);
  }

}
